import { Colors, Row } from '@microfrontends/react-components'
import styled from 'styled-components'
const sectionPadding = '35px 0'

export const InfoContainer = styled(Row)`
	background-color: ${Colors.primary};
	background-image: url(${process.env.IMAGE_BASE_URL}/numerology/base-bg.png);
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	padding: ${sectionPadding};
	position: relative;
`
export const H1 = styled.h1`
	font-family: 'Dela Gothic One';
	font-style: normal;
	font-weight: 400;
	font-size: 8vw;
	word-break: break-word;
	line-height: 1.3;
	color: #ffffff;
	text-align: center;
	margin: 25px 0;
	@media screen and (min-width: 768px) {
		font-size: 50px;
	}
`

export const CustomHeader = styled.div`
	span {
		font-size: 18px;
		line-height: 28px;
	}
`
export const DetailCss = styled(Row)`
	background-color: #fff;
	padding: ${sectionPadding};
	padding-bottom: 0;
	.vnw-collapse-header {
		padding: 10px 12px;
	}
	@media screen and (min-width: 768px) {
		.vnw-collapse-header {
			padding: 10px 48px;
		}
	}
`
export const CareerPathCss = styled(Row)`
	background-color: #fff;
	padding: ${sectionPadding};
	padding-top: 0;
`
